export default __webpack_public_path__ + "static/media/MovieCover.16c7b02c.jpg";